import type { Prototype } from "../prototype-types";

export const harshdipSinghDeoganPrototypes: Prototype[] = [
  {
    id: "hd-shopify-bestseller-nudge",
    name: "Shopify Bestseller Nudge",
    path: "/hd/shopify-bestseller-nudge",
    description:
      "Reuses existing Catalog Connect nudges to surface missing Shopify best-seller products for Shopify-integrated brands, showing them on various Brand Portal surfaces and a new banner to drive new-product order volume.",
    owner: "Harshdip Singh Deogan",
    createdAt: "2026-05-20",
    lastUpdated: "2026-05-20",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/5af84a5678d56e97fdc4cdb3c1e9a8f24a8899ac96ade3eccf859f668c66830a.png",
    project: "Shopify Bestseller Nudge",
    creationTool: "claude-code",
  },
  {
    id: "hd-bulk-upload",
    name: "Bulk Upload",
    path: "/hd/bulk-upload",
    description: "Static Brand Portal bulk upload & export screens",
    owner: "Harshdip Singh Deogan",
    createdAt: "2026-09-16",
    lastUpdated: "2026-09-16",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/hd-bulk-upload.png",
  },
];
